import React, { useMemo, useState } from "react";
import FilterEmp from "./FilterEmp";
import ContentList from "./ContentList";
import InstoreTableViewData from "./InstoreTableViewData";
import OnlineTableViewData from "../OnlineOrder/OnlineTableViewData";
import MainOnline from "../OnlineOrder/MainOnline";
import { useAuthDetails } from "../../../Common/cookiesHelper";
import DateRangeComponent from "../../../reuseableComponents/DateRangeComponent";
import useMultiSelect from "../../../hooks/useMultiSelect";
import { Link ,useNavigate, useLocation} from "react-router-dom";
// const transactionsList = [
//   {
//     title: "Cash & Credit Card",
//   },
//   {
//     title: "Cash",
//   },
//   {
//     title: "Credit Card",
//   },
// ];
// const transactionsListSuperadmin = [
//   {
//     title: "Cash & Credit Card",
//   },
//   {
//     title: "Cash",
//   },
//   {
//     title: "Credit Card",
//   },
//   {
//     title: "Unpaid",
//   },
// ];
const InStoreTransactionsList = [
  { id: 1, title: "Credit", apivalue: "Credit" },
  { id: 2, title: "Debit", apivalue: "Debit" },
  { id: 3, title: "Cash", apivalue: "Cash" },
  { id: 4, title: "Food EBT", apivalue: "FoodEbt" },
  { id: 5, title: "Cash EBT", apivalue: "CashEbt" },
  { id: 6, title: "Gift Card", apivalue: "Gift Card" },
  { id: 7, title: "Store Credit", apivalue: "Store Credit" },
  { id: 8, title: "Lottery", apivalue: "Lottery" },
  { id: 10, title: "Split", apivalue: "Split" },
];
const MainInStore = () => {
  const {
    LoginGetDashBoardRecordJson,
    LoginAllStore,
    userTypeData,
    GetSessionLogin,
    future_date,
  } = useAuthDetails();
  // console.log("userTypeData", userTypeData);
  // const { start_date, end_date, order_env, order_method } = useParams();
  // const [activeTab, setActiveTab] = useState("offline");
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = location.pathname.includes("online")
    ? "online"
    : "offline";

  const [OrderSourceData, setOrderSourceData] = useState(null);
  const [OrderTypeData, setOrderTypeData] = useState("New");
  const [OnlSearchIdData, setOnlSearchIdData] = useState("");
  const [OffSearchIdData, setOffSearchIdData] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [isloading, setIsLoading] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState("Both");
  const [employeeList, setemployeeList] = useState([]);
  const enhancedInStoreTransactionsList = useMemo(
    () =>
      userTypeData?.login_type === "superadmin"
        ? [
            ...InStoreTransactionsList,
            {
              id: 9,
              title: "Unpaid",
              apivalue: "Unpaid",
              className: "superadminGreen",
            },
          ]
        : InStoreTransactionsList,
    [userTypeData?.login_type]
  );

  // Payment Type uses local state instead of useMultiSelect: "All" means
  // every payment type EXCEPT the superadmin-only "Unpaid" — Unpaid is only
  // included when the user checks it explicitly.
  const nonUnpaidTransactions = useMemo(
    () =>
      enhancedInStoreTransactionsList.filter(
        (item) => item.apivalue !== "Unpaid"
      ),
    [enhancedInStoreTransactionsList]
  );
  const [selectedInStoreTransactionsList, setSelectedInStoreTransactionsList] =
    useState(nonUnpaidTransactions);
  // Derived: "All" is checked only while every non-Unpaid option is checked —
  // unchecking any one of them unchecks "All" automatically.
  const allInStoreTransactionsSelected =
    nonUnpaidTransactions.length > 0 &&
    nonUnpaidTransactions.every((opt) =>
      selectedInStoreTransactionsList.some((item) => item.id === opt.id)
    );
  // While "All" is active (every non-Unpaid option checked), lock the Unpaid
  // checkbox so it can't be mixed into the All state. Keep it enabled when it
  // is already checked, otherwise it could never be unchecked.
  const unpaidSelected = selectedInStoreTransactionsList.some(
    (item) => item.apivalue === "Unpaid"
  );
  const uncheckedNonUnpaidCount = nonUnpaidTransactions.filter(
    (opt) =>
      !selectedInStoreTransactionsList.some((item) => item.id === opt.id)
  ).length;
  const inStoreTransactionsOptions = enhancedInStoreTransactionsList.map(
    (item) => {
      if (item.apivalue === "Unpaid") {
        return {
          ...item,
          disabled: allInStoreTransactionsSelected && !unpaidSelected,
        };
      }
      // While Unpaid is checked, lock the LAST unchecked non-Unpaid option so
      // the selection can never grow into "every type + Unpaid" — at least
      // one other value must stay unchecked. Checked options stay enabled so
      // they can always be unchecked.
      const isChecked = selectedInStoreTransactionsList.some(
        (sel) => sel.id === item.id
      );
      return {
        ...item,
        disabled: unpaidSelected && !isChecked && uncheckedNonUnpaidCount === 1,
      };
    }
  );
  const handleInStoreTransactionsClick = (selectedItem) => {
    if (selectedItem === "All") {
      // Toggle: on -> check everything except Unpaid; off -> deselect all
      // (mirrors the old hook's deselect-all behavior).
      setSelectedInStoreTransactionsList(
        allInStoreTransactionsSelected ? [] : nonUnpaidTransactions
      );
      return;
    }
    setSelectedInStoreTransactionsList((prev) => {
      const exists = prev.some((item) => item.id === selectedItem.id);
      if (exists) {
        return prev.filter((item) => item.id !== selectedItem.id);
      }
      // Guard (mirrors the disabled flags): never allow the selection to
      // become "every non-Unpaid type + Unpaid".
      const hasUnpaid = prev.some((item) => item.apivalue === "Unpaid");
      const nonUnpaidChecked = prev.filter(
        (item) => item.apivalue !== "Unpaid"
      ).length;
      if (
        selectedItem.apivalue === "Unpaid"
          ? nonUnpaidChecked === nonUnpaidTransactions.length
          : hasUnpaid &&
            nonUnpaidChecked + 1 === nonUnpaidTransactions.length
      ) {
        return prev;
      }
      return [...prev, selectedItem];
    });
  };

  const {
    selectedItems: selectedInStoreEmployeeList,
    allOptionSelected: allInStoreEmployeeSelected,
    handleOptionClick: handleInStoreEmployeeClick,
  } = useMultiSelect(employeeList);
  // let futureDate = "5"
  const merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;
  const handleDateRangeChange = (dateRange) => {
    setSelectedDateRange(dateRange);
  };
  const handleTabClick = (tab) => {
    // setSearchId("");
    if (tab === "online") {
      navigate("/order/online");
    } else {
      navigate("/order");
    }
    // setActiveTab(tab);
    setOffSearchIdData("");
    setOnlSearchIdData("");
  };

  // const handleFilterChange = (identifier, SearchId) => {
  //   if (activeTab === "online") {
  //     // setOrderTypeData(identifier); // OrderType for online
  //     // setOnlSearchIdData(SearchId);
  //   } else {
  //     // setEmployeeIDData(identifier); // EmployeeID for offline
  //     setOffSearchIdData(SearchId);
  //   }
  // };

  const renderInStoreContent = () => {
    if (activeTab === "online") {
      return (
        <>
          <MainOnline
            selectedTransaction={selectedTransaction}
            setSelectedTransaction={setSelectedTransaction}
            setOrderSourceData={setOrderSourceData}
            setOrderTypeData={setOrderTypeData}
            setOnlSearchIdData={setOnlSearchIdData}
            OnlSearchIdData={OnlSearchIdData}
            OrderTypeData={OrderTypeData}
          />
        </>
      );
    } else if (activeTab === "offline") {
      return (
        <>
          <FilterEmp
            // onFilterEmpDataChange={handleFilterChange}
            // searchId={searchId}
            // setSearchId={setSearchId}
            // transactionsList={transactionsList}
            // transactionsListSuperadmin={transactionsListSuperadmin}

            //  for transaction sorting
            selectedInStoreTransactionsList={selectedInStoreTransactionsList}
            allInStoreTransactionsSelected={allInStoreTransactionsSelected}
            handleInStoreTransactionsClick={handleInStoreTransactionsClick}
            InStoreTransactionsList={inStoreTransactionsOptions}
            // for employee sorting
            employeeList={employeeList}
            setemployeeList={setemployeeList}
            selectedInStoreEmployeeList={selectedInStoreEmployeeList}
            allInStoreEmployeeSelected={allInStoreEmployeeSelected}
            handleInStoreEmployeeClick={handleInStoreEmployeeClick}
            OffSearchIdData={OffSearchIdData}
            setOffSearchIdData={setOffSearchIdData}
          />
        </>
      );
    }
    return null;
  };

  return (
    <>
      <div className="q-order-main-page">
        <div className="box">
          <div
            className="box_shadow_div_order"
            style={{ overflow: "unset", paddingBottom: "0px" }}
          >
            <div className="mb6_border">
              <div
                onClick={() => handleTabClick("offline")}
                className={`${
                  activeTab === "offline"
                    ? "bg-[#EBF2FF] text-[#0A64F9] font-circular-bold relative  cursor-pointer"
                    : "bg-white text-[#6A6A6A]  cursor-pointer"
                } orderfilter`}
              >
                Orders (In-Store)
              </div>
              <div
                onClick={() => handleTabClick("online")}
                className={`${
                  activeTab === "online"
                    ? "bg-[#EBF2FF] text-[#0A64F9]  font-circular-bold relative cursor-pointer"
                    : "bg-white text-[#6A6A6A] cursor-pointer"
                } orderfilter`}
              >
                Orders (Online)
              </div>
            </div>
            {
              // !searchId
              true && (
                <>
                  <div className="" style={{ paddingBottom: "0px" }}>
                    <h1 className="px-2 sm:px-5 pt-5">
                      View and manage all orders. Filter by date range, payment
                      type, or employee to find specific orders.
                    </h1>
                    <DateRangeComponent
                      isloading={isloading}
                      selectedDateRange={selectedDateRange}
                      onDateRangeChange={handleDateRangeChange}
                      future_date={future_date}
                    />
                  </div>
                </>
              )
            }
          </div>

          <div className="box_shadow_div_order">
            <div className="">{renderInStoreContent()}</div>
          </div>
          {activeTab === "online" && (
            <div className="q_dateRange_header">
              <ContentList />
            </div>
          )}

          <div className="q_dateRange_header">
            {activeTab === "offline" ? (
              <InstoreTableViewData
                OrderSourceData={OrderSourceData}
                selectedInStoreEmployeeList={selectedInStoreEmployeeList}
                OffSearchIdData={OffSearchIdData}
                selectedDateRange={selectedDateRange}
                merchant_id={merchant_id}
                userTypeData={userTypeData}
                setIsLoading={setIsLoading}
                // order_method={order_method}
                activeTab={activeTab}
                selectedInStoreTransactionsList={
                  selectedInStoreTransactionsList
                }
                allInStoreTransactionsSelected={allInStoreTransactionsSelected}
                employeeList={employeeList}
                enhancedInStoreTransactionsList={enhancedInStoreTransactionsList}
              />
            ) : (
              <OnlineTableViewData
                OrderSourceData={OrderSourceData}
                OrderTypeData={OrderTypeData}
                OnlSearchIdData={OnlSearchIdData}
                selectedDateRange={selectedDateRange}
                merchant_id={merchant_id}
                userTypeData={userTypeData}
                selectedTransaction={selectedTransaction}
                // order_env={order_env}
                // order_method={order_method}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MainInStore;
